var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5C11 12.2239 11.1865 12 11.4167 12H20.5833C20.8135 12 21 12.2239 21 12.5C21 12.7761 20.8135 13 20.5833 13H11.4167C11.1865 13 11 12.7761 11 12.5Z",
    fill: "#001024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5C15 18.2239 15.1865 18 15.4167 18H16.5833C16.8135 18 17 18.2239 17 18.5C17 18.7761 16.8135 19 16.5833 19H15.4167C15.1865 19 15 18.7761 15 18.5Z",
    fill: "#001024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5C13 15.2239 13.1865 15 13.4167 15H18.5833C18.8135 15 19 15.2239 19 15.5C19 15.7761 18.8135 16 18.5833 16H13.4167C13.1865 16 13 15.7761 13 15.5Z",
    fill: "#001024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5044afe617ce20e53f0b57ade56dcbd2.svg";
export { ForwardRef as ReactComponent };